import { Pipe, PipeTransform } from '@angular/core';

import { IconPrefix } from '@fortawesome/fontawesome-svg-core';

@Pipe({
  name: 'showIcon',
  standalone: true,
})
export class ShowIconPipe implements PipeTransform {
  transform(index: number, rating: number): IconPrefix {
    if (rating >= index + 1) {
      return 'fas';
    } else {
      return 'far';
    }
  }
}
